enum TagType {
  PLANNING = 1,
  BOOKING = 2,
  DOSSIER = 3,
  JOB = 4,
  OBSERVATION = 6,
}

export default TagType;